import {observer} from "mobx-react";
import {useStore} from "../../../stores/Store";
import SliderFilter from "./SliderFilter";

export default observer(function WeightFilter(){
    const {LanguageStore, AccordionStore} = useStore();
    const {currentLanguageMessages} = LanguageStore;
    const {filteredWeight, setFilteredWeight, findLightiestAndHeaviestWeight} = AccordionStore;

    const lightiestAndHeaviest = findLightiestAndHeaviestWeight();

    return (
        <SliderFilter
            value={filteredWeight}
            setValue={setFilteredWeight}
            title={currentLanguageMessages.AccordionsPage.Filter.Weight.title}
            unit={'kg'}
            min={lightiestAndHeaviest[0]}
            max={lightiestAndHeaviest[1]}
        />
    )
})